import { axios } from '@/services/axios';

const getOperatorConnectUsages = async (companyId, accountScope) => {
    const res = await axios.get(`/Company/${companyId}/OperatorConnectUsages`, {
        headers: {
            'X-RequestScope': accountScope,
        },
    });
    return res.data;
};

export default getOperatorConnectUsages;
